const styles = ({ screenSizes, typography }) => ({
  ...typography.h2,
  '& p': {
    ...typography.h2,
  },
  display: 'block',
  margin: 0,
  textAlign: 'left',

  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
    display: 'none',
  },
});

export default styles;
